ixModuleRouting("impactx.cube", {
    "/cube": {
        template: "<ixa-cube-detail></ixa-cube-detail>",
        templateUrl: "modules/cube/templates/cube.html",
        process: "CubeOrdering",
        controller: "CubeCtrl",
        controllerAs: "cubeCtrl",
        workspace: "monitor",
    },
    "/cube/:id": {
        template: "<ixa-cube-detail></ixa-cube-detail>",
        templateUrl: "modules/cube/templates/cube.html",
        process: "CubeOrdering",
        controller: "CubeCtrl",
        controllerAs: "cubeCtrl",
        workspace: "monitor",
    },
    "/storedcube/:id": {
        template: "<ixa-stored-cube-detail></ixa-stored-cube-detail>",
        templateUrl: "modules/cube/templates/storedcube.html",
        process: "CubeOrdering",
        controller: "StoredCubeCtrl",
        controllerAs: "storedCubeCtrl",
        workspace: "monitor",
    },
});
